<dx-lookup
  [dataSource]="periodeList()"
  valueExpr="id"
  [value]="selectedPeriodeId()"
  [displayExpr]="displayExpr"
  [searchEnabled]="true"
  [showClearButton]="true"
  [placeholder]="placeholder()"
  width="100%"
  (onValueChanged)="valueChanged($event)">

  <div *dxTemplate="let periode of 'item'">
    <div class="periode-item">
      <i class="far fa-calendar pn-border-color mg-r-5"></i>
      <span>{{ displayExpr(periode) }}</span>
    </div>
  </div>

  <div *dxTemplate="let periode of 'field'">
    @if (periode) {
      <div class="periode-field">
        <i class="far fa-calendar pn-border-color mg-r-5"></i>
        <span class="periode-field-text" [title]="displayExpr(periode)">{{ displayExpr(periode) }}</span>
      </div>
    } @else {
      <div class="dx-placeholder">{{ placeholder() }}</div>
    }
  </div>

  <dxo-drop-down-options [showTitle]="false"></dxo-drop-down-options>
</dx-lookup>
